import React, {useState, useEffect} from 'react'
import Template from '../component/template'
import {LoadEffect, TableLoader}  from '../component/loader'
import axios from 'axios'
import { Alerts, WarningModal} from '../component/notify'
import PageHeader from '../component/pageheader'
import {ServerUrl,  Token, staffName, ImagesUrl, config} from '../component/include'
import Select from 'react-select'
import { formatGroupLabel, longDate} from '../component/globalFunction'

import Error403 from '../settings/error403'
import { useLocation } from 'react-router-dom'
import { verifyRouter } from '../component/authentication'
import QuillText from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import {Type} from 'react-bootstrap-table2-editor';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

const Noticeboard =()=> {
    const [errors, setErrors] = useState({});
    
let location =  useLocation()
const [isAuthenticated, setIsAuthenticated] = useState(true);
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    }); 
   
    const [note, setNote]= useState({
       
        receiver:'Everyone',
        expiry:'0000-00-00 00:00:00',
        status:{value:'Active', label:'Active'},
        passport:'',
        description:'',
        studentClass:[],
        staffName:staffName
    })
    const [noticeDetails, setNoticeDetails]=useState([])
    const [allNoticeboard, setAllNoticeboard]=useState([])
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChangeData =(data)=>{
		setNote({...note, description : data });
	}

    const handleChange = event =>{
       setNote({...note, [event.target.name] : event.target.value });
       setErrors({...errors, [event.target.name]:''})
      
    }
    const handleSelect =(option, action)=>{ 
        setNote({...note, status:option})
         setErrors({...errors, [action.name]:''})
    }


    const  handleFile = function(fieldName){
        return function(newValue){  
       readURL(newValue);
       }
       
    } 
    
    
   
    const handleSubmit = event =>{
        event.preventDefault();    
        setErrors(ValidateErrors(note));
        setIsSubmitting(true);
    } 
      
    const ValidateErrors=(values)=>{
        let errors = {};   
       
        if(values.receiver==='Select Class'){
            if(values.studentClass.length===0){
                errors.studentClass ='Please select class';
            }
            
        } 
        if(!values.description){
            errors.description ='Please enter description';
        }
        return errors;
        }

    
    
    

    function submit(){        
        setNotice({...notice, 
            isLoading: true})         
            const fd = new FormData();
            fd.append('jwt', Token); 
            let formData = note; 
           for(let k in formData){
               fd.append(k,formData[k]);
           }; 

           let value = [];
     note.studentClass.map((std)=>{
        value.push({classID:std.classID, sectionID:std.value})
    })
    fd.append('noteStatus', note.status.value);
     fd.append('sectionList', JSON.stringify(value, null, 2));

           let url = ServerUrl+'/save_controller/tbl_noticeboard'
          axios.post(url, fd, config)
          .then(response =>{
            if(response.data.type ==='success'){
				
				Alerts('Saved!', 'success', response.data.message)
        window.location.reload()
					} else{

            setErrors({...errors, errorMessage: JSON.stringify(response.data)})
            window.scrollTo(0,0)
					}   
			})
			.catch((error)=>{
        setErrors({...errors, errorMessage: JSON.stringify(error.message)})
        window.scrollTo(0,0)
			}).finally(()=>{
        
        setNotice({...notice,  isLoading: false}) 
      })
    }




    useEffect(()=>{
        if(Object.keys(errors).length === 0 && isSubmitting){
        submit()
        }
        },[errors])


        const fetchNoticeboard =()=>{
            setNotice({...notice, 
                isDataFetching: true
            });
            const fd = new FormData();
            fd.append('jwt', Token); 
             let url = ServerUrl+'/fetch_controller/tbl_noticeboard'
             axios.post(url, fd, config).then(result=>{
                setNotice({...notice, 
                    isDataFetching: false
                });
                setAllNoticeboard(result.data)
            })
        }

const readURL = (input)=>{
       
    let displayMessage = '';
    const PreviewImage = input.target.name;
      //  let newImage = "viewPassport";
        var fileName = document.getElementById(PreviewImage).value;

    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile==="jpg" || extFile==="jpeg" || extFile==="png" || extFile==="gif" || extFile==="JPG" || extFile==="JPEG" || extFile==="PNG" || extFile==="GIF" || extFile==="PDF" || extFile==="pdf"){
        //TO DO    
        
         var FileSize = input.target.files[0].size / 1024 / 1024; // in MB
    if (FileSize > 1) {
        displayMessage = ' File uploaded is more than maximum size Allow. it exceeds 1 Mb';
       document.getElementById(input.target.name).value = '';
       setNote({...note, passport:''})
    } else {
        if (input.target.files && input.target.files[0]) { //Check if input has files.
            setNote({...note, passport:input.target.files[0]})
            var reader = new FileReader();//Initialize FileReader.
            reader.onload = function (e) {
             
            };
            reader.readAsDataURL(input.target.files[0]);
        }
    }
    }else{

        displayMessage = 'Only gif|jpg|png|jpeg|jpe|JPEG|PNG|JPG|PDF|pdf  files are allowed with maximum of 1MB'
        document.getElementById(input.target.name).value = '';
        setNote({...note, passport:''})
    }   
    
    if(displayMessage.length > 0){
        Alerts('Error!', 'danger', displayMessage)
    }
    
} 


const handleDelete =(ID)=>{
    let close =   document.getElementById('btnWarningDialog-'+ID)
    close.click();
   

    setNotice({...notice, isLoading: true}) 

        const fd = new FormData();
        fd.append('jwt', Token); 
    fd.append('ID', 'ID')
    fd.append('data', ID)
      
let url = ServerUrl+'/delete_controller/tbl_noticeboard'
      axios.post(url, fd, config)
      .then(response =>{
       if(response.data.type ==='success'){
          Alerts('Saved!', 'default', response.data.message)
              } else{
          Alerts('Error!', 'danger', JSON.stringify(response.data))
              }   
      })
      .catch((error)=>{
        Alerts('Error!', 'danger', error.message)
      }).finally(()=>{
          fetchNoticeboard()
          setNotice({...notice, 
              isLoading: false
          })
      }) 
}



				
const tableHeader = [
{dataField: 'code', text: 'Action', formatter:(cell, row)=><div>
 <button type='button' className='btn-danger' data-toggle="modal"   data-target={`#warningdialog-${row.ID}`}     title="Delete"><i className="icofont icofont-delete-alt"></i></button>
  
   <WarningModal message="This is very dangerous, you shouldn't do it! are you really really sure.?" handleAction={()=>handleDelete(row.ID)} mID={row.ID} /> 

</div>, editable: false},

{dataField: 'receiver',  text: 'Receiver', editable:false},
    {dataField: 'description',  text: 'Description',  formatter:(cell)=><span style={{display:'block',  width:300, whiteSpace:'normal', wordWrap:'break-word' }} dangerouslySetInnerHTML={{__html:cell}} ></span>,   sort: true, validator: (newValue, row, column) => {
        if (!newValue) {
          return {
            valid: false,
            message: 'Description'
          };
        }
        return true;
      }},
    {dataField: 'status',  text: 'Status', sort: true, formatter:(cell, row)=>row.status==='Active'? <div className="pcoded-badge label label-success">ACTIVE</div>: <div className="pcoded-badge label label-danger">INACTIVE</div>, editor: {
      type: Type.SELECT, options:[{value:'Active', label:'Active'},
      {value:'Inactive', label:'Inactive'}]

    }},


    {dataField: 'imageUrl', text: 'Url Link', formatter:(cell)=>cell!==""?<a href={ImagesUrl+"/noticeboard/"+cell} target="new" style={{color:'blue'}} title="view"> Click to View</a>:'', editable:false, sort: true},

    {dataField: 'expiry',  text: 'Expiry Date', editor: {
        type: Type.DATE
      }, formatter:(cell)=>longDate(cell), sort: true},
    {dataField: 'createdBy',  text: 'Created By', editable:false, hidden:true},
    {dataField: 'dateCreate',  text: 'Created On', editable:false, hidden:true},
 ];
 



 const RecordTable=(props)=>{

    const CustomToggleList = ({
        columns,
        onColumnToggle,
        toggles
      }) => ( 
      <div  className="btn-group btn-group-toggle btn-group-vertical" data-toggle="buttons">
          {
            columns
              .map(column => ({
                ...column,
                toggle: toggles[column.dataField]
              }))
              .map(column => (
                
                <button
                  type="button"
                  key={ column.dataField }
                  className={ ` btn btn-primary ${column.toggle ? 'active' : ''}` }
                  data-toggle="button"
                  aria-pressed={ column.toggle ? 'true' : 'false' }
                  onClick={ () => onColumnToggle(column.dataField) }
                >
                  { column.text }
                </button>
              ))
          }
        </div>
        
      );

    const handleUpdate=(column, newValue, ID)=>{       
      const fd = new FormData();
      fd.append('jwt', Token); 
         fd.append('columnField', newValue);
         fd.append('column', column.dataField);
         fd.append('ID', ID);
      
        let url = ServerUrl+'/updateById_controller/tbl_noticeboard'
       axios.post(url, fd, config)
       //.then(result => console.log(result.data))
       .then()
       .catch((error)=>console.log(error)) 
       
     } 
     const { SearchBar } = Search;
 
     const customTotal = (from, to, size) => (
        <span >&nbsp;Showing { from } to { to } of { size } items</span>
      );
     const options = {
         showTotal: true,
     paginationTotalRenderer: customTotal,
     sizePerPageList: [{text: '100', value: 100}, {text: '200', value: 200}, {text: '500', value: 500},
     { text: 'All', value: props.data.length }]
        
       };
  
     return <ToolkitProvider search columnToggle 
                 keyField='ID' data={ props.data } columns={ props.columns } >
                     
                     {
                         props => (
                         <div >
                           <div className="form-group">
                             <SearchBar
                             { ...props.searchProps } style={{height:'40px'}} className="form-control" placeholder="Type to search!!!" />
                             &nbsp;
                           
                             <div className="btn-group dropdown-split-success">
  
  <button type="button" className="btn btn-primary dropdown-toggle dropdown-toggle-split waves-effect waves-light" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
  <i className="fa fa-search-plus"></i> Columns
  </button>
  
  <div className="dropdown-menu" x-placement="bottom-start" style={{overflow:'scroll', height:'260px', width:'250px', position: 'absolute', transform: 'translate3d(113px, 40px, 0px)', top: '0px', left: '0px', willChange: 'transform'}}>
    <CustomToggleList { ...props.columnToggleProps } />
  </div>
  </div>

                             </div>
                             
                      
             
                             <BootstrapTable
                             { ...props.baseProps }
                                         striped
                                     hover
                                     condensed
                                     noDataIndication={<div className="alert alert-danger background-danger">No Record Found</div>}
                                 pagination={paginationFactory(options) }
                                 cellEdit={ cellEditFactory({
                                   mode: 'dbclick',
                                   blurToSave: true,
                                   autoSelectText: true,
                         beforeSaveCell: (oldValue, newValue, row, column) => {
                           if(oldValue !==newValue){
                           handleUpdate(column, newValue, row.ID);
                           
                          return '';
                         }
                         
                       }
                                 }) }
                             />
                         </div>
                         )
                     }
  </ToolkitProvider>
  }


useEffect(()=>{
  
  //setIsAuthenticated(verifyRouter(location.pathname))
    fetchNoticeboard()
},[]);



        return (  
          <>
         <div  className="main-body">
         {isAuthenticated?   <div className="page-wrapper">
                       {notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Noticeboard">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-commenting-o"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="#!">Communication</a> </li>
                    <li className="breadcrumb-item"><a href="#!">Noticeboard</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">


                {errors.errorMessage?
<div className="alert alert-danger background-danger">
        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
            <i className=" fa fa-times text-white"></i>
        </button>
        <strong> {errors.errorMessage}</strong> 
    </div>:''}


                <div className="row  ">
							

	<div className="col-sm-12">

    <div className="card z-depth-0">
		<div className="card-header">
			<h5><i className="fa fa-edit" ></i> Add Noticeboard</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div><div className="card-block">
        <div className="card z-depth-0">
		
        <div className="card-block">
          <div className="row">
                          
                          <section className="col-md-7">
                              <label>Receiver</label>
              
              <div className="form-group">
              <div className="form-radio">
        <div className="radio radio-inline"><label >
                <input type="radio" checked={note.receiver==='Everyone'} onChange={handleChange} value="Everyone"   name="receiver" />
                                <i className="helper"></i>Everyone</label></div>

            <div className="radio radio-inline"><label >
                <input type="radio"   checked={note.receiver==='Only Staff'} onChange={handleChange} value="Only Staff" name="receiver" />
                                <i className="helper"></i>Only Staff</label></div>

        <div className="radio radio-inline"><label >
                <input type="radio"   checked={note.receiver==='Only Student'} onChange={handleChange} value="Only Student" name="receiver" />
                                <i className="helper"></i>Only Student</label></div>

            <div className="radio radio-inline"><label >
                <input type="radio"   checked={note.receiver==='Only Applicant'} onChange={handleChange} value="Only Applicant" name="receiver" />
                                <i className="helper"></i>Only Applicant</label></div>
              
                                       </div>
                  </div></section>
              
                                  </div><hr/>
		<div className="row">
     <section className="col-md-12">
           <div className="form-group">
           <label > Description</label>
           <QuillText value={note.description} onChange={handleChangeData} /> 

           <span style={{color:'red'}}>{errors.description && errors.description}</span>
            </div>
     
     </section>

     <section className="col-md-6">
           <div className="form-group">
           <label > Image/PDF</label>
           <input id="passport"  onChange={handleFile('passport')} className="form-control" name="passport" type="file" accept="image/*" /> 
            </div>
     </section> 
				</div>	<hr/>

                <div className="row">
     <section className="col-md-6">
           <div className="form-group"><label > Expiry Date</label>
           <input   value={note.expiry} className={errors.expiry ? 'form-control form-control-danger' : 'form-control'} name="expiry" type="date"  onChange={handleChange} /> <span style={{color:'red'}}>{errors.expiry && errors.expiry}</span>

            </div>
     
     </section>

     <section className="col-md-6">
      <div className="form-group">
                        <label > Status</label>
                        <Select  options={[
                    { value: 'Active', label: 'Active' },
                    { value: 'Inactive', label: 'Inactive' },
                ]} 
              onChange={handleSelect}  name="status" value={note.status}  /> 
             </div>
     </section> 
				</div><hr/>

	<footer className="pull-right">
	
	<button type="button" id="submit" onClick={handleSubmit} className="btn btn-inverse "><i className="fa fa-save"></i> Save</button>
								</footer>				
							</div>
                            </div>
							</div></div>
</div>

</div>
	

<div className="row  ">   <div className="col-sm-12">
                                                
<div className="card z-depth-0">
            <div className="card-header">
                <h5><i className="fa fa-th" ></i> Listing All Noticeboard</h5>
                <div className="card-header-right">
                    <ul className="list-unstyled card-option">
                        <li><i className="feather icon-maximizes full-card"></i></li>
                        <li><i className="feather icon-minus minimize-card"></i></li>
                        <li><i className="feather icon-trash-2 close-card"></i></li>
                    </ul>
                </div>
            </div>
            <div className="card-block">         
        <div className="col-md-12 table-responsive">
         {notice.isDataFetching ? <TableLoader />:
         <RecordTable data={allNoticeboard}  columns={tableHeader}  /> 
        } 

</div>

</div>
    
    </div>
    
    </div>
    </div>




   </div>
          {/* The Page Body close here */}

            </div>:
            <Error403 />}
            </div>

</>
 );
        
}

export default React.memo(Noticeboard) 